import { AxiosRequestConfig } from 'axios';
import api from './api';
import { EngineeringResponsePaginated, EngineeringResponse, EngineeringRequest } from '../@types/engineeringTypes';

const engineeringUrl = '/api/eng_records/';
const mapUrl = 'map_side_list/';
const mapPointObjectUrl = 'map_info_point_line_object/';

// * Main * \\

function getEngineering(config: AxiosRequestConfig) {
    return api.get<EngineeringResponsePaginated>(engineeringUrl, config);
}

function getEngineeringsTileKey(config: AxiosRequestConfig) {
	return api.get<string>(engineeringUrl, config);
}

function getEngineeringById(id: string) {
    return api.get<EngineeringResponse>(`${engineeringUrl}${id}/`);
}

function createEngineering(engineeringData: EngineeringRequest) {
    return api.post(engineeringUrl, engineeringData);
}

function updateEngineering(id: string, updatedEngineeringData: EngineeringRequest) {
    return api.put(`${engineeringUrl}${id}/`, updatedEngineeringData);
}

async function deleteEngineeringById(id: string) {
    return api.delete(`${engineeringUrl}${id}/`); 
}

// * Maps * \\

function getEngMapInformationChart(config: AxiosRequestConfig) {
    return api.get(`${engineeringUrl}${mapUrl}`, config);
}

function getEngMapInformationPointLine(config: AxiosRequestConfig) {
    return api.get(`${engineeringUrl}${mapPointObjectUrl}`, config);
}

// * Exports * \\
const engineeringServices = {
    getEngineering,
    getEngineeringsTileKey,
    getEngineeringById,
    createEngineering,
    updateEngineering,
    deleteEngineeringById,
    getEngMapInformationChart,
    getEngMapInformationPointLine
}

export default engineeringServices;